import React from 'react';

function Attribution() {
  return (
    <div className="attribution">
      Challenge by{' '}
      <a
        href="https://www.frontendmentor.io?ref=challenge"
        target="_blank"
        rel="noopener noreferrer"
      >
        Frontend Mentor
      </a>
      . Coded by{' '}
      <a
        href="https://acielochoa.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Aciel Ochoa
      </a>
      .
    </div>
  );
}

export default Attribution;
